export const ROUTE_PARAMS_CONSTANTS = {
  RETURN_URL: 'returnUrl',
} as const;

export const APPLICATION_ROUTES_CONSTANTS = {
  ROUTES: {
    AFTER_LOGIN: 'library',
    DASHBOARD: 'dashboard',
    HOME: 'home',
    PRIVACY: 'privacy',
    TERMS: 'terms',
    ABOUT_US: 'about-us',

    REVIEW_SESSION: {
      REVIEW_SESSION: 'reader',
      FLASHCARD: (id: string) => `/reader/review-session/${id}`,
      STATS: (id: string) => `/reader/review-session/${id}/stats`,
    },
    SOURCES: 'library',
    HIGHLIGHTS: 'highlights',
    REMINDER_LOGS: 'reminder-logs',
    USER_SETTINGS: 'user-settings',
    EXPORT: 'export',
    SETTINGS: 'settings',
    AUTHENTICATION: {
      LOGIN: 'authentication/login',
      GET_VERIFICATION_CODE: 'authentication/get-verification-code',
      SUBMIT_VERIFICATION_CODE: 'authentication/submit-verification-code',
      SIGN_UP: 'authentication/sign-up'
    },
    USER: {
      USER: 'user',
      PROFILE: 'user/profile',
    },
    IMPORT: {
      IMPORT: 'import',
      EXCEL: {
        IMPORT: 'import/excel',
        CONFIRM_IMPORT: 'import/excel/confirm',
      },
      KINDLE_HTML: {
        IMPORT: 'import/kindle-html',
        GUIDE: 'import/kindle-html/guide',
        CONFIRM_IMPORT: 'import/kindle-html/confirm',
      },
      APPLE_BOOK: {
        IMPORT: 'import/apple-book',
        GUIDE: 'import/apple-book/guide',
        CONFIRM_IMPORT: 'import/apple-book/confirm',
      },
    }
  },
  BASES: {
    AUTHENTICATION: 'authentication',
  },
  ACTIONS: {
    PROFILE: 'profile',
    LOGIN: 'login',
    GET_VERIFICATION_CODE: 'get-verification-code',
    SUBMIT_VERIFICATION_CODE: 'submit-verification-code',
    SIGN_UP: 'sign-up',
    EXCEL_IMPORT: 'excel',
    EXCEL_CONFIRM_IMPORT: 'excel/confirm',
    KINDLE_HTML_IMPORT: 'kindle-html',
    KINDLE_HTML_CONFIRM_IMPORT: 'kindle-html/confirm',
    KINDLE_HTML_IMPORT_GUIDE: 'kindle-html/guide',
    APPLE_BOOK_IMPORT: 'apple-book',
    APPLE_BOOK_CONFIRM_IMPORT: 'apple-book/confirm',
    APPLE_BOOK_IMPORT_GUIDE: 'apple-book/guide',
    REVIEW_SESSION: {
      FLASHCARD_ROUTE_TEMPLATE: 'review-session/:id',
      STATS_ROUTE_TEMPLATE: 'review-session/:id/stats',
    }
  },
} as const;

export const APPLICATION_ROUTES_STATES_CONSTANTS = {
  EXCEL_IMPORT_DATA: 'EXCEL_IMPORT',
  KINDLE_HTML_IMPORT_DATA: 'KINDLE_HTML_IMPORT_DATA',
  APPLE_BOOK_IMPORT_DATA: 'APPLE_BOOK_IMPORT_DATA'
} as const;
